import { BaseClient } from '../BaseClient';
import {
  AssociatedChangeOrder,
  AssociatedEstimate,
  Contract,
  ContractBudget,
  GetContractByCustomIdRequest,
  GetContractsRequest,
  GetContractsResponse,
} from '../compiled-protos/unity_build';
import { UnityBuildServiceClient } from '../compiled-protos/unity_build.client';

class UnityBuildClient extends BaseClient {
  self: UnityBuildServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new UnityBuildServiceClient(this.transport);
  }

  /**
   * Fetch multiple contracts by a list of custom IDs (job numbers).
   */
  public async GetContracts(req: GetContractsRequest) {
    let res = GetContractsResponse.create();
    try {
      res = await this.self.getContracts(req, this.getMetaData()).response;
    } catch (err) {
      console.error(err);
      return;
    }
    return res;
  }

  /**
   * Fetch a single contract by its custom ID (job number).
   */
  public async GetContractByCustomId(req: GetContractByCustomIdRequest) {
    let res = Contract.create();
    try {
      res = await this.self.getContractByCustomId(req, this.getMetaData()).response;
    } catch (err) {
      console.error(err);
      return;
    }
    return res;
  }
}

export {
  UnityBuildClient,
  // Types
  GetContractsRequest,
  GetContractsResponse,
  GetContractByCustomIdRequest,
  Contract,
  ContractBudget,
  AssociatedEstimate,
  AssociatedChangeOrder,
}; 